import React from "react"
import { motion } from "framer-motion"
import logo from "../assets/logo.jpg"

export const Header: React.FC = () => {
	return (
		<header className='flex justify-between items-center p-6 bg-primary text-white'>
			<motion.div
				initial={{ x: -100, opacity: 0 }}
				animate={{ x: 0, opacity: 1 }}
				transition={{ duration: 0.5 }}
				className='flex items-center space-x-3'>
				{/* Logo */}
				<div className='flex-shrink-0'>
					<img src={logo} alt='logo' className='w-10 h-10 object-contain' />
				</div>
				{/* Full Name */}
				<span className='text-xl font-bold'>USŁUGI DLA FIRM</span>
			</motion.div>
			<motion.nav
				initial={{ x: 100, opacity: 0 }}
				animate={{ x: 0, opacity: 1 }}
				transition={{ duration: 0.5 }}>
				<ul className='flex space-x-6'>
					<li>
						<a href='#about' className='hover:text-accent'>
							O nas
						</a>
					</li>
					<li>
						<a href='#services' className='hover:text-accent'>
							Usługi
						</a>
					</li>
					<li>
						<a href='#contact' className='hover:text-accent'>
							Kontakt
						</a>
					</li>
				</ul>
			</motion.nav>
		</header>
	)
}
